import { inject as o } from "vue";
import { k as e } from "./key.CDkYzFpi.js";
const r = {
  mainColor: {
    base: "#333333",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  fontColor: "#333333",
  actionColor: {
    base: "#32BFC8",
    washed: "rgba(51, 51, 51, 0.24)",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  actionContrastColor: {
    base: "#FFFFFF",
    over: "#333333",
    contrasted: "#333333"
  },
  backgroundColor: {
    base: "#FFFFFF",
    over: "#2CB0B8",
    washed: "rgba(51, 51, 51, 0.24)",
    dimmed: "rgba(51, 51, 51, 0.24)",
    contrasted: "#333333"
  },
  border: !1,
  borderColor: "#333333",
  borderRadius: "8px"
}, s = () => o(e, r);
export {
  s as u
};
//# sourceMappingURL=useTheme.L4REnSCw.js.map
